import React, { useEffect, useState } from "react";
import StateSummaryCard from "./components/StateSummaryCard";
import { useAdminContext } from "../../Hooks/AdminContext";
import { _Get_Dashboard_Data } from "../../DAL/Listing/Dashbaord";
import CustomTable from "../../components/customTable/CustomTable";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { formatNumber, show_proper_words } from "../../utils/constant";
import moment from "moment";
import StatusChip from "../../theme/chip";
import CustomCircularProgress from "../../components/CustomCircularProgress";

const Dashboard = () => {
  const { setnavbarTitle } = useAdminContext();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [dashboardData, setDashboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  const GetDashboardData = async () => {
    initialLoad ? setLoading(true) : setInitialLoad(true);
    const response = await _Get_Dashboard_Data(page, rowsPerPage);
    if (response.code === 200) {
      if (initialLoad) {
        setDashboardData([
          {
            title: "Total Subscription Earnings",
            count:
              "$" + formatNumber(response?.data?.total_subscriptions_earning),
            color: "#121212",
            icon: "mdi:currency-usd",
          },
          {
            title: "Total Users",
            count: response?.data?.total_customers || 0,
            color: "#121212",
            icon: "mdi:account-group",
          },
          {
            title: "Total Active Subscriptions",
            count: response?.data?.total_active_subscriptions || 0,
            color: "#121212",
            icon: "mdi:credit-card-check",
          },
        ]);
      }
      setUserList(response?.data.pending_deposit);
      setTotalCount(response?.data?.total_count);
      setTotalPages(response?.data?.total_pages);
      setLoading(false);
      setInitialLoad(false);
    } else {
      setLoading(false);
      setInitialLoad(false);
      // enqueueSnackbar(response?.message, { variant: "error" });
    }
  };

  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              onClick={() => {
                navigate(`/dashboard/deposit-detail/${row?._id}`);
              }}
              style={{ fill: "#fff", marginRight: "10px", cursor: "pointer" }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <span
          className="pointer"
          onClick={() => navigate(`/deposit-request/deposit-detail/${row._id}`)}
        >
          {row?.user_info?.first_name + " " + row?.user_info?.last_name ||
            "_ _"}
          <div className="text-muted small">
            {row?.user_info?.email || "_ _"}
          </div>
        </span>
      ),
    },
    // {
    //   id: "name",
    //   label: "Request Title",
    // },
    {
      id: "deposit_method",
      label: "Deposit Method",
      renderData: (row) => (
        <div>
          {row.deposit_method === "crypto"
            ? "Crypto Transfer"
            : row.deposit_method === "credit_card"
            ? "Credit Card Transfer"
            : show_proper_words(row.deposit_method) || "_ _"}
        </div>
      ),
    },
    {
      id: "amount",
      label: "Amount",
      renderData: (row) => <div>${formatNumber(row?.amount) || "0"}</div>,
    },
    {
      id: "transaction_date",
      label: "Transaction Date",
      renderData: (row) => (
        <div>{moment(row?.date_time).format("DD MMM YY hh:mm A") || "_ _"}</div>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip
          status={
            row?.status === "succeeded"
              ? "Approved"
              : row?.status === "failed"
              ? "Rejected"
              : row?.status === "requires_action"
              ? "Needs Changes"
              : "Pending"
          }
          type="activeInactive"
        />
      ),
    },
  ];

  useEffect(() => {
    setnavbarTitle("Dashboard");
    GetDashboardData();
  }, [page, rowsPerPage]);

  if (loading) {
    return <CustomCircularProgress />;
  }
  return (
    <div className="container-fluid mt-4">
      <p>Welcome back, 👋</p>

      <div className="row">
        {dashboardData.map((stat, index) => (
          <div className="col-12 col-lg-4 mt-3 mt-lg-0" key={index}>
            <StateSummaryCard
              title={stat.title}
              count={stat.count}
              icon={stat.icon}
              percentage={stat.percentage}
              color={stat.color}
            />
          </div>
        ))}

        {initialLoad ? (
          <CustomCircularProgress />
        ) : (
          <div className="col-12 mt-3">
            <CustomTable
              data={userList ? userList : []}
              TABLE_HEAD={User_Table_Head}
              MENU_OPTIONS={[]}
              custom_pagination={{
                total_count: totalCount,
                rows_per_page: rowsPerPage,
                page: page,
                handleChangePage: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage,
              }}
              pageCount={pageCount}
              totalPages={totalPages}
              handleChangePages={handleChangePages}
              pagePagination={true}
              is_hide={true}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
